import { createSelector } from 'reselect';

const selectDomain = (state) => state.confirmButton;

export const selectConfirmed = createSelector(
  [selectDomain], (state) => state.get('confirmed'),
);
